import AbstractController from '../../../Controller/AbstractController';
import Controller from '../../../Controller/Controller';

/**
 * Location Controller
 *
 * @class
 */
class LocationController extends AbstractController {
  /**
   * @constructor
   */
  constructor() {
    super();

    Controller.registerController(this);
  }
}

export default new LocationController();
